// extracted by css-extract-rspack-plugin
export default {"field":"SkM20fwDHmIXCDdD"};